export const paletteLookup = palette => shade => palette[shade];
export const paletteValidator = (startShade, endShade) => shade => {
   if (shade < startShade || shade > endShade || shade % 100 !== 0) {
      throw new Error(
         `Palette index [${shade}] is invalid. Must be multiple of 100 between ${startShade} and ${endShade}.`
      );
   }

   return shade;
};

export const highlightPaletteValidator = (...keys) => key => {
   if (keys.indexOf(key) < 0) {
      throw new Error(`Highlight Palette at key[${key}] could not be found.`);
   }

   return key;
};



// WEBPACK FOOTER //
// ./src/UI/themes/functions.js